import React, { useState } from "react";

const Contact: React.FC = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<null | "sent" | "error">(null);

  // Simple client-side "send" that opens a mail client if available.
  // Replace with real API call if you have a backend endpoint.
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(null);

    if (!name.trim() || !email.trim() || !message.trim()) {
      setStatus("error");
      return;
    }

    const subject = encodeURIComponent(`Website contact from ${name}`);
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`
    );

    // open user's mail client as fallback
    window.location.href = `mailto:hello@yourdomain.com?subject=${subject}&body=${body}`;

    // optimistic UX
    setStatus("sent");
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <main className="min-h-screen bg-white text-brandNavy py-20">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-4xl font-bold mb-6">Contact Us</h1>

        <p className="text-base text-mutedGray mb-6">
          Need help or have a question? Fill the form and we'll get back to you
          within 1–2 business days.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-semibold mb-1">Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-brandNavy"
              placeholder="Your name"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-semibold mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-brandNavy"
              placeholder="you@example.com"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-semibold mb-1">Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-brandNavy"
              rows={6}
              placeholder="How can we help?"
              required
            />
          </div>

          <div>
            <button
              type="submit"
              className="bg-brandRed text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition"
            >
              Send Message
            </button>
          </div>

          {status === "sent" && (
            <div className="text-green-700 font-semibold">Message sent.</div>
          )}
          {status === "error" && (
            <div className="text-red-600 font-semibold">
              Please complete all fields.
            </div>
          )}
        </form>

        <div className="mt-12 text-mutedGray">
          <h3 className="text-xl font-semibold mb-2">Other ways to reach us</h3>
          <p className="mb-1">Email: info@adeoluadegbemi.com</p>
          <p>WhatsApp: +234 815 607 6714</p>
        </div>
      </div>
    </main>
  );
};

export default Contact;
